// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"182":"40d8b13156a37bf2de8c","840":"276965aa09ee14cc1be4","911":"4613875d8235fd451c76","945":"f22de4b6145219b0e2cf"}[chunkId] + ".chunk.js";
};